module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_1@3x.76be9049.png";